import { SertifikatPengetahuanInterface } from "../../../data/contracts/SertifikatPengetahuan";
import { SertifikatPengetahuanTTEDataMapper } from "../../../data/mappers/SertifikatPengetahuanTTE";
import { SertifikatPengetahuan } from "../../../entities/SertifikatPengetahuan";
import { Endpoints } from "../../misc/Endpoints";
import ApiService from "../../services/ApiService";

export class SertifikatPengetahuanRepository implements SertifikatPengetahuanInterface {
    private apiService: ApiService;
    private mapper: SertifikatPengetahuanTTEDataMapper;
    private endpoints: Endpoints;

    constructor(
        apiService: ApiService,
        mapper: SertifikatPengetahuanTTEDataMapper,
        endpoints: Endpoints
    ) {
        this.apiService = apiService;
        this.mapper = mapper;
        this.endpoints = endpoints;
    }

    public async getDataTTESertifikatPengetahuan(pagePengetahuan: number, perPagePengetahuan: number): Promise<SertifikatPengetahuan> {
        const headers = new Map<string, string>();

        const dataResponse = await this.apiService.invoke(
            'get',
            this.endpoints.sertifikatPengetahuanEndpoint(),
            {
                page: pagePengetahuan,
                per_page: perPagePengetahuan,
            },
            null,
            headers
        );
        return this.mapper.convertSertifikatPengetahuanTTEData(dataResponse);
    }

    public async tteSertifikatPengetahuan(
        pengetahuan_id: number,
        isTteUlang: boolean,
        akun_tte_id: number,
        user_id?: number,
        isManagement?: boolean 
    ): Promise<any> {
        const headers = new Map<string, string>();

        const base = isManagement
            ? 'management_content/pengetahuan'
            :  this.endpoints.sertifikatPengetahuanEndpoint();

        const endpoint = isManagement 
            ? `${base}/${pengetahuan_id}/peserta/${user_id}/sertifikat${
                isTteUlang ? '/regenerate' : '/generate'
            }`
            : `${base}/${pengetahuan_id}/peserta${
                isTteUlang ? '/regenerate' : '/generate'
            }`;

        const formData = new FormData();
        formData.append('akun_tte_id', akun_tte_id.toString());

        const dataResponse = await this.apiService.invoke(
            'post',
            endpoint,
            null,
            formData,
            headers
        );

        return dataResponse;
    }

    public async tteSertifikatPengetahuanPemateri(
        pengetahuan_id: number,
        isTteUlang: boolean,
        akun_tte_id: number,
    ): Promise<any> {
        const headers = new Map<string, string>();

        const base = this.endpoints.sertifikatPengetahuanEndpoint();

        const endpoint = `${base}/${pengetahuan_id}/pemateri${
            isTteUlang ? '/regenerate' : '/generate'
        }`;

        const formData = new FormData();
        formData.append('akun_tte_id', akun_tte_id.toString());

        const dataResponse = await this.apiService.invoke(
            'post',
            endpoint,
            null,
            formData,
            headers
        );

        return dataResponse;
    }
}
